import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  HStack
} from '@chakra-ui/react'
import { FC } from 'react'
import { MdAddCircleOutline } from 'react-icons/md'
import ReactSelect from 'react-select'

import EmailChipInput from '@component/FollowUpFornecedor/EmailChipInput'
import FuModalHeader from '@component/FollowUpFornecedor/ModalHeader'

import { ICreateConfigPayload } from '@base/@types/providers/FollowUpFornecedor/ConfigProvider'

interface Props {
  isOpen: boolean
  form: ICreateConfigPayload
  setForm: (fn: (f: ICreateConfigPayload) => ICreateConfigPayload) => void
  supplierOptions: { value: any; label: string }[]
  centerOptions: { value: any; label: string }[]
  loadingFilters: boolean
  onClose: () => void
  onCreate: () => void
}

const CreateModal: FC<Props> = ({
  isOpen,
  form,
  setForm,
  supplierOptions,
  centerOptions,
  loadingFilters,
  onClose,
  onCreate
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    isCentered
    scrollBehavior="inside"
    motionPreset="slideInBottom"
    size="xl"
  >
    <ModalOverlay />
    <ModalContent>
      <FuModalHeader
        icon={MdAddCircleOutline}
        title="Nova Configuração de E-mail"
      />
      <ModalCloseButton color="white" />
      <ModalBody bg="white" py={5}>
        <FormControl mb={4} isRequired>
          <FormLabel fontSize="sm">Fornecedor(es)</FormLabel>
          <ReactSelect
            isMulti
            isLoading={loadingFilters}
            options={supplierOptions}
            placeholder="Selecionar fornecedor(es)..."
            onChange={opts =>
              setForm(f => ({
                ...f,
                supplierIds: (opts as any[]).map(o => Number(o.value))
              }))
            }
          />
        </FormControl>
        <FormControl mb={4} isRequired>
          <HStack justify="space-between" mb={1}>
            <FormLabel fontSize="sm" mb={0}>
              Centro(s)
            </FormLabel>
            <Text
              fontSize="11px"
              color={
                centerOptions.length === 0 || loadingFilters
                  ? 'gray.300'
                  : 'green.600'
              }
              fontWeight="600"
              cursor={
                centerOptions.length === 0 || loadingFilters
                  ? 'not-allowed'
                  : 'pointer'
              }
              userSelect="none"
              onClick={() => {
                if (centerOptions.length === 0 || loadingFilters) return
                const allSelected =
                  form.storeIds.length === centerOptions.length
                setForm(f => ({
                  ...f,
                  storeIds: allSelected
                    ? []
                    : centerOptions.map(o => Number(o.value))
                }))
              }}
            >
              {form.storeIds.length === centerOptions.length &&
              centerOptions.length > 0
                ? 'Desmarcar Todos'
                : 'Selecionar Todos'}
            </Text>
          </HStack>
          <ReactSelect
            isMulti
            isLoading={loadingFilters}
            options={centerOptions}
            value={centerOptions.filter(o =>
              form.storeIds.includes(Number(o.value))
            )}
            placeholder="Selecionar centro(s)..."
            onChange={opts =>
              setForm(f => ({
                ...f,
                storeIds: (opts as any[]).map(o => Number(o.value))
              }))
            }
          />
        </FormControl>
        <FormControl isRequired>
          <FormLabel fontSize="sm">
            E-mail(s) de contato
            <Text
              as="span"
              fontSize="11px"
              color="gray.500"
              ml={2}
              fontWeight="normal"
            >
              (tecle Enter ou vírgula para adicionar)
            </Text>
          </FormLabel>
          <EmailChipInput
            value={form.emails}
            onChange={emails => setForm(f => ({ ...f, emails }))}
          />
        </FormControl>
      </ModalBody>
      <ModalFooter
        bg="white"
        borderBottomLeftRadius={5}
        borderBottomRightRadius={5}
      >
        <Button colorScheme="blue" mr={3} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          bg="green.600"
          color="white"
          _hover={{ bg: 'green.500' }}
          _active={{ bg: 'green.500' }}
          onClick={onCreate}
          isDisabled={
            form.emails.length === 0 ||
            form.supplierIds.length === 0 ||
            form.storeIds.length === 0
          }
        >
          Salvar
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
)

export default CreateModal
